import { MultiSelect } from 'primereact/multiselect';
import { useDispatch, useSelector } from 'react-redux';
import { CopyToClipboard, StatusSelector, BaseChip, BaseCollectionTypeSelector, BaseTabsMenu, BaseInput, BaseImageUpload } from './index';
import {
  SET_COLLECTION_PROP,
  UPDATE_SUBSCRIPTIONS,
  UPDATE_ADDITIONAL_SUBSCRIPTION
} from '../store/modules/collection';
import './css/key-details-section.scss';
import {
  HOSTED,
  EDITORIAL,
  CUSTOM,
  PARTNER_COLLECTION,
  EDITORIAL_INDEPENDENT
} from '../utils/Constants';
import { useState } from 'react';
import { updateCollectionImg } from '../store/api';

export const CollectionKeyDetails = function () {
  const {
    subscriptionsList,
    additionalSubscriptionsList,
    data: { id, status, title, locale, partnersLogo, accessResources, partnerName, type, partnershipType, stripeId, collectionPrice }
  } = useSelector((state) => state.collection);

  const additionalSubscriptionsGroup = [
    {
      label: 'Journal',
      items: additionalSubscriptionsList.slice(0, 8)
    },
    {
      label: 'India course',
      items: additionalSubscriptionsList.slice(8, 48)
    },
    {
      label: 'Customer',
      items: additionalSubscriptionsList.slice(48, 52)
    },
    {
      label: 'Collection/Topic',
      items: additionalSubscriptionsList.slice(52, 56)
    },
    {
      label: 'China',
      items: additionalSubscriptionsList.slice(56, 57)
    },
    {
      label: 'BMA',
      items: additionalSubscriptionsList.slice(57, 62)
    },
    {
      label: 'Research to Publication',
      items: additionalSubscriptionsList.slice(62, 63)
    }
  ];
  const partnershipTypeOptions = [HOSTED, EDITORIAL_INDEPENDENT, CUSTOM]
  const [handlePartnershipType, setHandlePartnershipType] = useState(partnershipType)

  const dispatch = useDispatch();

  function handlePropUpdate({ key, value }) {
    dispatch(SET_COLLECTION_PROP({ key, value }));
  }

  function handleUpdateSubscriptions(arr) {
    dispatch(UPDATE_SUBSCRIPTIONS(arr));
  }

  function handleAdditional(arr) {
    dispatch(UPDATE_ADDITIONAL_SUBSCRIPTION(arr));
  }

  function handleCollectionPartnershipType({ value }) {
    (value === EDITORIAL ? setHandlePartnershipType(EDITORIAL_INDEPENDENT) : setHandlePartnershipType(value))
    switch (value) {
      case HOSTED:
        return dispatch(SET_COLLECTION_PROP({ key: 'partnershipType', value: HOSTED }));
      case EDITORIAL_INDEPENDENT:
        return dispatch(SET_COLLECTION_PROP({ key: 'partnershipType', value: EDITORIAL }));
      case CUSTOM:
        return dispatch(SET_COLLECTION_PROP({ key: 'partnershipType', value: CUSTOM }));

      default:
        dispatch(SET_COLLECTION_PROP({ key: 'partnershipType', value: '' }));
        break;
    }

  }

  async function handleImage({ key, action, imageName, formData }) {
    switch (action) {
      case 'upload':
        dispatch(
          SET_COLLECTION_PROP({
            key,
            value: key === 'partnersLogo' ? [imageName] : imageName
          })
        );
        await updateCollectionImg(formData);
        break;
      case 'delete':
        dispatch(
          SET_COLLECTION_PROP({
            key,
            value: key === 'partnersLogo' ? null : ''
          })
        );
        break;
    }
  }

  function handleInput({ key, value }) {
    dispatch(SET_COLLECTION_PROP({ key, value }));
  }
  const handleKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    // Allow control keys (backspace, etc. charCode < 32)
    // Allow digits (48-57) and period (46)
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      event.preventDefault();
    }
  };

  return (
    <section className="key-details-section" id="key-details">
      <header className="flex flex-between">
        <h2>Key details</h2>
        <div className="flex-center">
          <BaseCollectionTypeSelector value={type} onChange={handlePropUpdate} />
          <StatusSelector name="status" status={status} onChange={handlePropUpdate} />
        </div>
      </header>
      {type === PARTNER_COLLECTION && <div className='m-b-24'>
        <BaseTabsMenu
          name='partnershipType'
          label="Partnership type"
          value={handlePartnershipType}
          options={partnershipTypeOptions}
          onSelect={handleCollectionPartnershipType}
        />
      </div>}

      <div>
        <label htmlFor="title">
          Collection title
          <br />
          <textarea
            className="w100"
            cy="collection-title"
            id="title"
            value={title}
            onInput={(ev) => handlePropUpdate({ key: 'title', value: ev.target.value })}
            placeholder="collection title"
          />
        </label>
        <span>Locale: {locale}</span>
      </div>

      <div className="unique-updated flex m-t-24">
        <div className="m-r-24">
          <label htmlFor="unique">
            Unique ID <br />
            <input
              type="text"
              cy="course-id"
              id="unique"
              value={id || ''}
              disabled
              onInput={() => { }}
            />
          </label>
          <CopyToClipboard />
        </div>
      </div>

      <div className="subscriptions-chips m-t-24" cy="subscriptions">
        <b>Subscriptions</b>
        <br />
        {subscriptionsList?.map(({ displayName, id }) => (
          <BaseChip
            label={displayName}
            id={id}
            key={id}
            selected={accessResources?.map((o) => o.id).some((val) => +val === +id)}
            section="keyDetails"
            onClick={handleUpdateSubscriptions}
          />
        ))}
      </div>
      {type === PARTNER_COLLECTION && partnershipType === HOSTED && <div className="m-r-24 m-t-24">
        <BaseInput
          name='stripeId'
          width='stripe-id'
          label="Stripe ID"
          value={stripeId}
          onInput={handlePropUpdate}
        />
      </div>}
      <div id="bmj-journals-subscriptions" className="relative m-t-24">
        <label htmlFor="additional" cy="additional-subscriptions">
          Additional subscriptions <br />
          <MultiSelect
            value={accessResources?.filter(({ id }) => +id > 2)}
            options={additionalSubscriptionsGroup}
            onChange={(e) => handleAdditional(e.value)}
            optionLabel="displayName"
            optionGroupLabel="label"
            optionGroupChildren="items"
            placeholder="Search all other subscriptions"
            display="chip"
            filter
            resetFilterOnHide
          />
        </label>
      </div>
      {type === PARTNER_COLLECTION && partnershipType === HOSTED && <div className="m-t-24 m-r-24">
        <b>Price</b>
        <br />
        <label htmlFor={'price'} className=" m-t-24 price-input">
          <span>{'£'}</span>
          <input
            name='price'
            type="text"
            id='price'
            value={!collectionPrice ? '' : collectionPrice}
            onKeyPress={handleKeyPress}
            onInput={(ev) => handleInput({ key: 'collectionPrice', value: ev.target.value })}
          />
        </label>
      </div>}
      {type === PARTNER_COLLECTION && <>
        <div className="partner-name m-r-24 m-t-24 m-b-24">
          <BaseInput
            name='partnerName'
            label="Partner name"
            value={partnerName}
            onInput={({ value }) => handlePropUpdate({ key: 'partnerName', value })}
          />
        </div>
        <BaseImageUpload
          name="partnersLogo"
          label="Partner logo"
          imageName={partnersLogo && partnersLogo[0]}
          handleImage={handleImage}
        />
      </>
      }
    </section>
  );
};
